import clsx from "clsx";
import * as React from "react";

import { Button, Grid, makeStyles, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  priceBtn: {
    display: "flex",
    borderRadius: "30px",
    margin: "5px !important",
    border: `1px solid ${theme.palette.landing.light}`,
    padding: "0 4px !important",
    height: "40px !important",
    "&:hover": {
      transform: "none",
    },
    "& *": {
      color: theme.palette.landing.light,
    },
  },
  currency: {
    fontSize: "1.1rem !important",
    [theme.breakpoints.down("md")]: {
      fontSize: "1.1rem !important",
    },
  },
  donateValue: {
    paddingRight: "10px",
    fontSize: "1.1rem !important",
    [theme.breakpoints.down("md")]: {
      fontSize: "1.1rem !important",
    },
  },
  activeTab: {
    backgroundColor: theme.palette.landing.main,
    "& *": {
      color: "white",
    },
    "&:hover": {
      backgroundColor: theme.palette.landing.main,
    },
  },

  gridClass: {
    maxWidth: "15%",
    margin: "2px",
    [theme.breakpoints.down("md")]: {
      maxWidth: "30%",
    },
  },
  selectedBtn: {
    borderRadius: "10px",
    display: "block",
    margin: "auto",
    width: "25%",
    backgroundColor: "#009693",
    color: "#fff",
    border: ".2px solid #009693",
    borderRight: ".2px solid #009693",
  },
  CBtn: {
    display: "block",
    margin: "auto",
    width: "25%",
    backgroundColor: "#fff",
    color: "#009693",
    border: ".2px solid #009693",
    borderRight: ".2px solid #009693",
    borderRadius: "10px",
  },
}));

const staticData = [
  {
    value: 50000,
    showVal: "50",
  },
  {
    value: 100000,
    showVal: "100",
  },
  {
    value: 200000,
    showVal: "200",
  },
];

const SelectSupportValue = ({ amount, handleTabChanged }) => {
  const classes = useStyles();
  return (
    <Grid
      item
      container
      // xs={12}
      sm={12}
      md={12}
      justify="center"
      alignItems="center"
      className={classes.itemContainer}
    >
      {staticData.map((item) => (
        <Grid key={item.value} item xs sm md className={classes.gridClass}>
          <Button
            variant="outlined"
            fullWidth
            onClick={() => handleTabChanged(item.value)}
            className={clsx(
              classes.priceBtn,
              +amount === item.value && classes.activeTab
            )}
          >
            <Typography variant="caption" className={classes.donateValue}>
              {item.showVal}
            </Typography>
            <Typography variant="caption" className={classes.currency}>
              هزار تومان
            </Typography>
          </Button>
        </Grid>
      ))}
    </Grid>
  );
};

export default SelectSupportValue;
